import GerenciarSustentacaoOralDialog from '@/components/shared/GerenciarSustentacaoOralDialog';
import SustentacaoOralEletronicaDialog from '@/components/shared/SustentacaoOralEletronicaDialog';
import EstadoSustentacaoOral, { ESTADO_SUSTENTACAO_ORAL } from '@/dominio/EstadoSustentacaoOral';
import { MEIO_JULGAMENTO_PROCESSO } from '@/dominio/MeioJulgamentoProcesso';
import { MEIO_JULGAMENTO_SESSAO } from '@/dominio/MeioJulgamentoSessao';
import { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';
import { SITUACAO_INSCRICAO_ADVOGADO } from '@/dominio/SituacaoInscricaoAdvogado';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';
import ErrorUtil from '@/util/ErrorUtil';
import NumeroProcessoUtil from '@/util/NumeroProcessoUtil';
import { faUserTie as IconeParticipacaoAdvogado } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Warning from '@mui/icons-material/Warning';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    IconButton,
    Radio,
    RadioGroup,
    Stack,
    Tooltip,
    Typography
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { action, computed, makeObservable, observable, runInAction, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../css/advogadoProcesso.css';
import Configuracao from '../../util/Configuracao';
import AutoComplete from '../AutoComplete';
import ModalEdicaoAdvogadoProcesso from '../ModalEdicaoAdvogadoProcesso';
import ReactComponent from '../ReactComponent';

dayjs.extend(customParseFormat);

class AdvogadoOption {
    constructor(oabNumero, oabLetra, oabUf, nome) {
        this.numero = oabNumero;
        this.letra = oabLetra;
        this.siglaUf = oabUf;
        this.nome = nome;
    }
}

class IncluirSustentacaoOral extends ReactComponent {
    parteSelecionada;
    formaPesquisaNomeAdv = 'inicia';
    opcoesAdvogados = [];
    valorCampoTextoAdvogado = '';
    advogadoSelecionado;
    modoParticipacao = '';
    presenca = '';
    sequencia;
    dataSolicitacaoInscricaoObj = '';

    aberto = false;
    aguardandoConsultaAdvogados = false;
    abrirAdvogados = false;

    inscricao = {};
    documentos = [];
    estadoSustentacaoOral = '';

    advogadoAnterior = null;
    parteAnterior = null;
    dataSolicitacaoInscricaoAnteriorObj = null;
    sequencialDigitacao = undefined;
    executandoAcao = false;

    static QTD_MINIMA_CARACTERES_PARA_PESQUISAR = 4;
    static ESTRUTURA_INFO_ADVOGADO_PESQUISA =
        /^((?<apenas_nome>[^\d/-]+)|((?<numero>\d+)((?<separador_letra>-{1})?(?<letra>[A-Za-z]{1}))?((?<separador_uf>\/{1})?(?<uf>[A-Za-z]{2}))?((?<separador_oab_nome>( - ){1}| +)(?<nome>[^\d/-]+))?))$/;
    static ESTRUTURA_INFO_ADVOGADO_COMPLETA =
        /^(?<numero>\d+)((?<separador_letra>-{1})(?<letra>[A-Z]{1}))?(?<separador_uf>\/{1})(?<uf>[A-Z]{2})(?<separador_oab_nome> - {1})(?<nome>.+)$/;

    constructor(props) {
        super(props);

        makeObservable(this, {
            parteSelecionada: observable,
            formaPesquisaNomeAdv: observable,
            opcoesAdvogados: observable,
            valorCampoTextoAdvogado: observable,
            advogadoSelecionado: observable,
            modoParticipacao: observable,
            presenca: observable,
            sequencia: observable,
            dataSolicitacaoInscricaoObj: observable,
            aberto: observable,
            aguardandoConsultaAdvogados: observable,
            abrirAdvogados: observable,
            inscricao: observable,
            documentos: observable,
            estadoSustentacaoOral: observable,
            executandoAcao: observable,
            registro: computed,
            abrir: action,
            fechar: action,
            opcoesPartes: computed,
            handleChangeAdvogado: action,
            abrirAutoCompleteAdvogado: action,
            fecharAutoCompleteAdvogado: action,
            handleChangeParte: action,
            campoTextoAdvogado: computed,
            handleInputChangeAdvogado: action,
            handleChangeFormaPesquisaAdvogado: action,
            handleChangeModoParticipacaoAdv: action,
            handleChangePresencaAdv: action,
            handleChangeEstadoSustentacaoOral: action,
            handleChangeDataInscricao: action,
            updateDataInscricao: action,
            isDadosNovosIguaisAosAntigos: computed,
            codigoMeioJulgamentoSessao: computed,
            isJulgamentoExclusivamenteVirtual: computed,
            isJulgamentoPresencial: computed,
            callbackCadastrarAdvogado: action,
            handleClickGravarInscricaoAdvogado: action,
            excluirSustentacaoOral: action,
            incluirSustentacaoOral: action,
            alterarSustentacaoOral: action,
            isControlePresencaDesabilitado: computed,
            isParticipacaoVirtual: computed,
            isDadosInconsistentes: computed,
            isItensObrigatoriosPreenchidos: computed,
            dicaBotaoGravar: computed,
            msgDadosObrigatorios: computed,
            titulo: computed,
            handleSelectDocumentos: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    /**
     * Chave para identificar o registro do advogado unicamente.
     *
     * @param {object} adv Advogado
     * @returns {string} Chave única para o advogado.
     */
    getRepresentanteKey(adv) {
        if (adv && adv.nome && adv.regOAB && adv.regOAB.numero && adv.regOAB.siglaUf) {
            if (adv.regOAB.letra) {
                return `${adv.nome}|${adv.regOAB.numero}-${adv.regOAB.letra}-${adv.regOAB.siglaUf}`;
            } else {
                return `${adv.nome}|${adv.regOAB.numero}-${adv.regOAB.siglaUf}`;
            }
        }

        return '';
    }

    abrir = () => {
        if (this.registro?.pedidoSustentacaoOral?.sequencia) {
            this.sequencia = this.registro.pedidoSustentacaoOral.sequencia;
        }

        if (this.observableProps.editar) {
            let parte = null;

            if (this.observableProps.parte) {
                this.parteAnterior = JSON.parse(JSON.stringify(this.observableProps.parte));
                parte = this.opcoesPartes.find((opcao) => this.observableProps.parte.nome === opcao.valor.nome);
            }

            if (parte) {
                this.handleChangeParte(parte);
            }

            if (this.observableProps.advogado) {
                const chaveAdv = this.getRepresentanteKey(this.observableProps.advogado);
                this.advogadoSelecionado = toJS(this.observableProps.advogado);
                this.modoParticipacao = this.advogadoSelecionado.modoParticipacao;
                this.presenca = this.advogadoSelecionado.presente;

                const inscricao = this?.registro?.detalhes?.inscricoes?.find(
                    (inscricao) =>
                        inscricao.codigoDaParte === this.observableProps.parte?.codigo &&
                        inscricao.advogado.regOAB.id === this.observableProps.advogado?.regOAB?.id
                );
                if (inscricao) {
                    this.inscricao = inscricao;
                    this.estadoSustentacaoOral = inscricao.estadoSustentacaoOral?.id || '';
                }

                if (this.advogadoSelecionado.dataSolicitacaoSustentacao) {
                    // @ts-ignore
                    this.dataSolicitacaoInscricaoObj = dayjs(
                        this.advogadoSelecionado.dataSolicitacaoSustentacao,
                        Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO
                    );
                    // @ts-ignore
                    this.dataSolicitacaoInscricaoAnteriorObj = this.dataSolicitacaoInscricaoObj.clone();
                }
                this.sequencialDigitacao = this.advogadoSelecionado.sequencialDigitacao;
                this.advogadoAnterior = JSON.parse(JSON.stringify(this.advogadoSelecionado));
                this.chaveAdvAnterior = chaveAdv;
            } else {
                this.advogadoAnterior = null;
                this.chaveAdvAnterior = '';
            }
        } else {
            this.updateDataInscricao();
        }

        this.aberto = true;
    };

    fechar = () => {
        this.aguardandoConsultaAdvogados = false;
        this.valorCampoTextoAdvogado = '';
        this.abrirAdvogados = false;
        this.aberto = false;
        this.parteSelecionada = null;
        this.advogadoSelecionado = null;
        this.opcoesAdvogados = [];
        this.modoParticipacao = '';
        this.presenca = '';
        this.dataSolicitacaoInscricaoObj = '';
        this.advogadoAnterior = null;
        this.parteAnterior = null;
        this.dataSolicitacaoInscricaoAnteriorObj = null;
        this.sequencialDigitacao = undefined;
        this.estadoSustentacaoOral = '';
    };

    get opcoesPartes() {
        const registro = this.registro;
        const opcoes = [];

        if (registro?.detalhes?.partesProcessuais) {
            registro.detalhes.partesProcessuais.forEach((partesProcesso) => {
                partesProcesso.partes.forEach((parte) => {
                    const p = {};
                    p.tipo = partesProcesso.denominacao;
                    p.polo = partesProcesso.tipoPolo;
                    p.nome = parte.parte.nome;
                    p.representantes = parte.representantes;
                    p.codigo = parte.parte.codigo;

                    opcoes.push({
                        valor: p,
                        texto: p.nome
                    });
                });
            });
        }

        return opcoes;
    }

    handleChangeAdvogado = async (option) => {
        this.fecharAutoCompleteAdvogado();
        this.advogadoSelecionado = null;

        if (option?.valor) {
            if (option.valor.regOAB) {
                this.advogadoSelecionado = option.valor;
            } else {
                const opcoes = await this.getOpcoesAdvogados(option.valor.nome);

                runInAction(() => {
                    this.opcoesAdvogados = opcoes;
                    return this.opcoesAdvogados;
                });

                if (this.opcoesAdvogados.length === 0) {
                    this.mensagemStore.abrirMensagemAlerta(
                        'O nome e/ou OAB informado(s) não foi(foram) encontrado(s) no cadastro de advogados do Tribunal.'
                    );
                } else if (this.opcoesAdvogados.length === 1) {
                    runInAction(() => (this.advogadoSelecionado = this.opcoesAdvogados[0].valor));
                } else {
                    this.mensagemStore.abrirMensagemAlerta('Selecione o advogado. Verifique o número da OAB.');
                    this.abrirAutoCompleteAdvogado();
                }
            }
        }

        this.updateDataInscricao();
    };

    abrirAutoCompleteAdvogado = () => {
        this.abrirAdvogados = true;
    };

    fecharAutoCompleteAdvogado = () => {
        this.abrirAdvogados = false;
    };

    handleChangeParte = (option) => {
        this.parteSelecionada = null;
        this.opcoesAdvogados = [];

        if (option && option.valor) {
            this.parteSelecionada = option.valor;

            if (option.valor.representantes) {
                const advogados = option.valor.representantes.filter((rep) => rep.tipo === 'ADVOGADO');

                this.opcoesAdvogados = advogados.map((advogado) => {
                    return {
                        valor: advogado,
                        texto: advogado.nome
                    };
                });
            }
        }

        this.updateDataInscricao();
    };

    advogadoOptionValueToObject(advString, digitando = false) {
        let ESTRUTURA_TEXTO;

        if (digitando) {
            ESTRUTURA_TEXTO = IncluirSustentacaoOral.ESTRUTURA_INFO_ADVOGADO_PESQUISA;
        } else {
            ESTRUTURA_TEXTO = IncluirSustentacaoOral.ESTRUTURA_INFO_ADVOGADO_COMPLETA;
        }

        const resultado = ESTRUTURA_TEXTO.exec(advString);

        if (!resultado?.groups) {
            return null;
        }

        const numeroOab = resultado.groups.numero ? resultado.groups.numero : '';
        const letraOab = resultado.groups.letra ? resultado.groups.letra.toUpperCase() : '';
        const ufOab = resultado.groups.uf ? resultado.groups.uf.toUpperCase() : '';
        const nome = resultado.groups.nome
            ? resultado.groups.nome
            : resultado.groups.apenas_nome
              ? resultado.groups.apenas_nome
              : '';

        return new AdvogadoOption(numeroOab, letraOab, ufOab, nome);
    }

    isMesmaOpcaoAdvogado(option, value) {
        const opcaoObj = this.advogadoOptionValueToObject(option);
        const valorObj = this.advogadoOptionValueToObject(value, true);

        const opcao = this.aplicarMascaraAdvogadoOption(opcaoObj);
        const valor = this.aplicarMascaraAdvogadoOption(valorObj);

        return opcao === valor;
    }

    aplicarMascaraAdvogadoOption(advogadoOption) {
        if (!advogadoOption) {
            return '';
        }

        if (advogadoOption.numero) {
            return `${advogadoOption.numero}${advogadoOption.letra ? `-${advogadoOption.letra}` : ''}${advogadoOption.siglaUf ? `/${advogadoOption.siglaUf}` : ''}${advogadoOption.nome ? ` - ${advogadoOption.nome}` : ''}`;
        } else {
            return advogadoOption.nome ? advogadoOption.nome : '';
        }
    }

    aplicarMascaraObjetoAdvogado = (advogado) => {
        if (!advogado || !advogado.regOAB) {
            return '';
        }

        return this.aplicarMascaraAdvogadoOption(
            new AdvogadoOption(advogado.regOAB.numero, advogado.regOAB.letra, advogado.regOAB.siglaUf, advogado.nome)
        );
    };

    aplicarMascaraTextoAdvogado = (valor) => {
        if (!valor) {
            return '';
        }

        const valorObj = this.advogadoOptionValueToObject(valor, true);

        if (valorObj) {
            return this.aplicarMascaraAdvogadoOption(valorObj);
        } else {
            return valor;
        }
    };

    setValorCampoTextoAdvogado = (valor) => {
        this.valorCampoTextoAdvogado = this.aplicarMascaraTextoAdvogado(valor);
    };

    get campoTextoAdvogado() {
        if (this.advogadoSelecionado && this.valorCampoTextoAdvogado === '') {
            return this.aplicarMascaraObjetoAdvogado(this.advogadoSelecionado);
        }

        return this.valorCampoTextoAdvogado;
    }

    // @ts-ignore
    handleInputChangeAdvogado = async (event, valor) => {
        if (valor) {
            this.setValorCampoTextoAdvogado(valor);
            const advObj = this.advogadoOptionValueToObject(valor, true);

            const podeConsultarAdvogadosPeloNome = !!(
                !this.aguardandoConsultaAdvogados &&
                advObj?.nome?.trim().length >= IncluirSustentacaoOral.QTD_MINIMA_CARACTERES_PARA_PESQUISAR
            );

            if (advObj?.numero || podeConsultarAdvogadosPeloNome) {
                this.aguardandoConsultaAdvogados = true;
                const opcoes = await this.getOpcoesAdvogados(
                    // @ts-ignore
                    advObj.numero ? '' : advObj.nome?.trim(),
                    // @ts-ignore
                    advObj.numero,
                    // @ts-ignore
                    advObj.siglaUf,
                    // @ts-ignore
                    advObj.letra
                );

                runInAction(() => {
                    this.opcoesAdvogados = opcoes;
                    this.aguardandoConsultaAdvogados = false;
                });
            }
        } else {
            this.setValorCampoTextoAdvogado('');
            this.fecharAutoCompleteAdvogado();
        }
    };

    getOpcoesAdvogados = async (nome, oab, siglaUf, letraOab) => {
        const formaPesquisa = this.formaPesquisaNomeAdv === 'contem' ? true : false;
        const advogados = await this.advogadoSustentacaoOralService.consultarAdvogados(
            nome,
            oab,
            siglaUf,
            letraOab,
            formaPesquisa
        );
        return advogados.data ? advogados.data.map((advogado) => this.novaOpcaoAdvogado(advogado)) : [];
    };

    novaOpcaoAdvogado = (advogado) => {
        return {
            valor: advogado,
            texto: this.aplicarMascaraObjetoAdvogado(advogado)
        };
    };

    handleChangeFormaPesquisaAdvogado = (event) => {
        this.formaPesquisaNomeAdv = event.target.value;
    };

    handleChangeModoParticipacaoAdv = (event) => {
        this.modoParticipacao = event.target.value;

        if (
            this.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo ||
            this.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo ||
            this.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo
        ) {
            this.presenca = SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.codigo;
        }

        this.updateDataInscricao();
    };

    handleChangePresencaAdv = (event) => {
        this.presenca = event.target.value;
        this.updateDataInscricao();
    };

    handleChangeEstadoSustentacaoOral = async (event) => {
        const codEstado = Number.parseInt(event.target.value, 10);

        if (!this.inscricao?.id) {
            this.estadoSustentacaoOral = codEstado;
            return;
        }

        const estadoAnteriorLocal = this.estadoSustentacaoOral;
        const estadoAnteriorInscricao = this.inscricao.estadoSustentacaoOral;
        const estadoAnteriorAdvogado = this.observableProps.advogado?.estadoSustentacaoOral;
        const novoEstado = {
            id: codEstado,
            descricao: EstadoSustentacaoOral.getDescricaoByCodigo(codEstado)
        };

        // Atualização otimista: reflete o estado pretendido no modal e no objeto compartilhado (popover).
        runInAction(() => {
            this.estadoSustentacaoOral = codEstado;
            this.inscricao.estadoSustentacaoOral = novoEstado;

            if (this.observableProps.advogado) {
                this.observableProps.advogado.estadoSustentacaoOral = novoEstado;
            }
        });

        try {
            const response = await this.advogadoSustentacaoOralService.alterarEstadoInscricao(
                this.inscricao.id,
                codEstado
            );

            if (response !== true) {
                throw new Error(typeof response === 'string' ? response : 'Erro ao alterar o estado da sustentação oral.');
            }

            await this.advogadoSustentacaoOralService.notificarAlteracaoAdvogado(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                this.sessaoStore.clienteEnvelopeId
            );
        } catch (error) {
            // Rollback: desfaz a marcação otimista (modal e objeto compartilhado) ao falhar a requisição.
            console.error(error);
            runInAction(() => {
                this.estadoSustentacaoOral = estadoAnteriorLocal;
                this.inscricao.estadoSustentacaoOral = estadoAnteriorInscricao;

                if (this.observableProps.advogado) {
                    this.observableProps.advogado.estadoSustentacaoOral = estadoAnteriorAdvogado;
                }
            });
            // A mensagem de erro do backend é exibida pelo interceptor global de resposta (evita ruído duplicado).
        }
    };

    handleChangeDataInscricao = (value) => {
        if (value && value.isValid()) {
            this.advogadoSelecionado.dataSolicitacaoSustentacao = value.format(
                Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO
            );
            // @ts-ignore
            this.dataSolicitacaoInscricaoObj = dayjs(
                this.advogadoSelecionado.dataSolicitacaoSustentacao,
                Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO
            );
        } else {
            this.advogadoSelecionado.dataSolicitacaoSustentacao = '';
        }
    };

    updateDataInscricao() {
        if (!this.observableProps.editar) {
            // @ts-ignore
            this.dataSolicitacaoInscricaoObj = dayjs();
        }
    }

    get isDadosNovosIguaisAosAntigos() {
        if (!this.observableProps.editar) {
            return false;
        }

        return (
            this.advogadoSelecionado &&
            this.chaveAdvAnterior === this.getRepresentanteKey(this.advogadoSelecionado) &&
            this.parteSelecionada?.nome &&
            this.parteAnterior?.nome === this.parteSelecionada.nome &&
            this.dataSolicitacaoInscricaoObj.isSame(this.dataSolicitacaoInscricaoAnteriorObj)
        );
    }

    get codigoMeioJulgamentoSessao() {
        if (this.sessaoStore?.sessaoSelecionada) {
            return this.sessaoStore.sessaoSelecionada.tipoJulgamento;
        }

        return '';
    }

    get isJulgamentoExclusivamenteVirtual() {
        return this.codigoMeioJulgamentoSessao === MEIO_JULGAMENTO_SESSAO.VIRTUAL.codigo;
    }

    get isJulgamentoPresencial() {
        return [
            MEIO_JULGAMENTO_PROCESSO.REMETIDO_PARA_SESSAO_VINCULADA.codigo,
            MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo
        ].includes(this.registro.tipoJulgamento);
    }

    isJulgamentoExclusivamentePresencial() {
        return SituacaoJulgamentoProcessoBusiness.isJulgamentoExclusivamentePresencial(
            this.sessaoStore?.sessaoSelecionada
        );
    }

    callbackCadastrarAdvogado = (advogado) => {
        this.advogadoSelecionado = advogado;
    };

    handleClickGravarInscricaoAdvogado = async () => {
        this.updateDataInscricao();

        if (!this.isItensObrigatoriosPreenchidos) {
            this.mensagemStore.abrirMensagemAlerta(this.msgDadosObrigatorios);
        } else if (!this.observableProps.editar && this.isSustentacaoOralCadastrada()) {
            this.mensagemStore.abrirMensagemAlerta('O advogado já está cadastrado.');
        } else {
            this.executandoAcao = true;

            try {
                this.advogadoSelecionado.modoParticipacao = this.modoParticipacao;
                this.advogadoSelecionado.presente = this.presenca;
                this.advogadoSelecionado.dataSolicitacaoSustentacao = this.dataSolicitacaoInscricaoObj.format(
                    Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO
                );

                this.advogadoSelecionado.sequencialDigitacao = this.sequencialDigitacao;

                if (this.observableProps.editar) {
                    this.sequencia = this.registro.pedidoSustentacaoOral.sequencia;
                    const parteMudou =
                        this.parteAnterior &&
                        this.parteSelecionada &&
                        this.parteAnterior.codigo !== this.parteSelecionada.codigo;
                    if (parteMudou) {
                        // A chave da inscrição é OAB+parte; o PUT in-place não move entre partes.
                        // Move de parte permanece como exclusão + reinserção.
                        const sucessoExclusao = await this.excluirSustentacaoOral();
                        if (sucessoExclusao) {
                            await this.incluirSustentacaoOral();
                        }
                    } else {
                        await this.alterarSustentacaoOral();
                    }
                } else {
                    await this.incluirSustentacaoOral();
                }
            } finally {
                runInAction(() => {
                    this.executandoAcao = false;
                });
            }
        }
    };

    getNumeroSiglaOAB(advogado) {
        if (!advogado?.regOAB) {
            return '';
        }

        const letra = advogado.regOAB.letra ? `-${advogado.regOAB.letra}` : '';
        return `${advogado.regOAB.numero}-${advogado.regOAB.siglaUf}${letra}`;
    }

    excluirSustentacaoOral = async () => {
        const response = await this.advogadoSustentacaoOralService.excluirSustentacaoOral(
            this.registro.sessaoId,
            this.registro.processo.numeroCompleto,
            this.getNumeroSiglaOAB(this.advogadoAnterior),
            // @ts-ignore
            this.parteAnterior.codigo
        );

        runInAction(() => {
            if (response !== true) {
                this.mensagemStore.abrirMensagemErro(response);
            }
        });

        return response === true;
    };

    incluirSustentacaoOral = async () => {
        let response;

        try {
            response = await this.advogadoSustentacaoOralService.incluirSustentacaoOral(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                this.advogadoSelecionado,
                this.parteSelecionada,
                this.sequencia,
                this.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
                    ? this.documentos
                    : []
            );

            if (response === true) {
                this.fechar();
                await this.salaSessaoStore.recarregarProcesso(this.registro);
                this.salaSessaoStore.ordenarProcessos();

                this.advogadoSustentacaoOralService.notificarAlteracaoAdvogado(
                    this.registro.sessaoId,
                    this.registro.processo.numeroCompleto,
                    this.sessaoStore.clienteEnvelopeId
                );

                this.mensagemStore.abrirMensagemSucesso(
                    `Inscrição de advogado ${this.observableProps.editar ? 'alterada' : 'incluída'} com sucesso.`
                );
            } else {
                throw new Error(ErrorUtil.getMensagemErroServico(response));
            }
        } catch (error) {
            // Mantém o modal aberto no erro; a mensagem do backend é exibida pelo interceptor global de resposta.
            console.error(error);
        }
    };

    alterarSustentacaoOral = async () => {
        let response;

        try {
            response = await this.advogadoSustentacaoOralService.alterarSustentacaoOral(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                this.advogadoAnterior,
                this.parteAnterior,
                this.advogadoSelecionado,
                this.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
                    ? this.documentos
                    : [],
                this.sequencia
            );

            if (response === true) {
                this.fechar();
                await this.salaSessaoStore.recarregarProcesso(this.registro);
                this.salaSessaoStore.ordenarProcessos();

                this.advogadoSustentacaoOralService.notificarAlteracaoAdvogado(
                    this.registro.sessaoId,
                    this.registro.processo.numeroCompleto,
                    this.sessaoStore.clienteEnvelopeId
                );

                this.mensagemStore.abrirMensagemSucesso('Inscrição de advogado alterada com sucesso.');
            } else {
                throw new Error(ErrorUtil.getMensagemErroServico(response));
            }
        } catch (error) {
            // Mantém o modal aberto no erro; a mensagem do backend é exibida pelo interceptor global de resposta.
            console.error(error);
        }
    };

    isSustentacaoOralCadastrada = () => {
        const advogado = this.advogadoSelecionado;
        let retorno = false;

        if (this.registro?.pedidoSustentacaoOral?.pedidosDetalhados) {
            retorno =
                this.registro.pedidoSustentacaoOral.pedidosDetalhados.findIndex(
                    (pedido) =>
                        pedido.advogados.findIndex(
                            (adv) =>
                                adv.regOAB?.numero === advogado.regOAB.numero &&
                                ((!adv.regOAB.letra && !advogado.regOAB.letra) ||
                                    adv.regOAB.letra === advogado.regOAB.letra) &&
                                adv.regOAB.siglaUf === advogado.regOAB.siglaUf &&
                                pedido.codigoDaParte === this.parteSelecionada?.codigo
                        ) > -1
                ) > -1;
        }

        return retorno;
    };

    renderOpcaoPresencial(descricaoOpcao) {
        return this.isJulgamentoExclusivamenteVirtual ? (
            <Stack direction="row">
                {descricaoOpcao}
                {this.isJulgamentoExclusivamenteVirtual && (
                    <Tooltip
                        title={
                            <Typography>
                                Opção incompatível com a modalidade da sessão e(ou) o meio de julgamento do processo.
                            </Typography>
                        }
                    >
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
            </Stack>
        ) : (
            descricaoOpcao
        );
    }

    renderOpcaoVirtual() {
        return this.isJulgamentoExclusivamentePresencial() ? (
            <Stack direction="row">
                {MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.descricao}
                {this.isJulgamentoExclusivamentePresencial() && (
                    <Tooltip
                        title={
                            <Typography>
                                Opção incompatível com a modalidade da sessão e(ou) o meio de julgamento do processo.
                            </Typography>
                        }
                    >
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
            </Stack>
        ) : (
            MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.descricao
        );
    }

    renderMotivosImpedimentoPedidoDestaque() {
        if (this.registro.processo?.permiteSustentacaoDetalhes?.possuiDestaqueIndeferidoNaFase) {
            return (
                <Tooltip title={<Typography>Processo já possui pedido de destaque indeferido nessa fase.</Typography>}>
                    <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                </Tooltip>
            );
        } else if (!this.registro.processo.permiteDestaque) {
            return (
                <Tooltip title={<Typography>A classe processual não permite destaque.</Typography>}>
                    <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                </Tooltip>
            );
        }
    }

    renderOpcaoPedidoDestaque() {
        return (
            <Stack direction="row">
                {MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.descricao}
                {!SituacaoJulgamentoProcessoBusiness.isProcessoPautadoEmJulgamentoExclusivamenteVirtual(
                    this.sessaoStore.sessaoSelecionada.tipoJulgamento
                ) && (
                    <Tooltip
                        title={
                            <Typography>
                                Opção incompatível com a modalidade da sessão e(ou) o meio de julgamento do processo.
                            </Typography>
                        }
                    >
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
                {this.renderMotivosImpedimentoPedidoDestaque()}
            </Stack>
        );
    }

    renderOpcaoSustentacaoOralEletronica() {
        return (
            <Stack direction="row">
                {MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.descricao}
                {SituacaoJulgamentoProcessoBusiness.isProcessoRemetido(
                    this.registro.tipoJulgamento,
                    this.registro.remessaJulgamento
                ) && (
                    <Tooltip
                        title={
                            <Typography>
                                Não é necessário realizar a inscrição de sustentação oral eletrônica, pois o processo já
                                foi remetido por outro motivo.
                            </Typography>
                        }
                    >
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
                {this.registro.tipoJulgamento === MEIO_JULGAMENTO_PROCESSO.PRESENCIAL.codigo && (
                    <Tooltip
                        title={
                            <Typography>
                                Opção incompatível com a modalidade da sessão e(ou) o meio de julgamento do processo.
                            </Typography>
                        }
                    >
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
                {!this.registro.processo.permiteSustentacao && (
                    <Tooltip title={<Typography>A classe processual não permite sustentação.</Typography>}>
                        <Warning style={{ marginLeft: '5px', color: 'darkorange', width: '20px', height: '20px' }} />
                    </Tooltip>
                )}
            </Stack>
        );
    }

    get isControlePresencaDesabilitado() {
        return !this.isJulgamentoPresencial || this.isParticipacaoVirtual || this.isDadosNovosIguaisAosAntigos;
    }

    get isParticipacaoVirtual() {
        return [
            MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo,
            MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo,
            MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo
        ].includes(this.modoParticipacao);
    }

    get isDadosInconsistentes() {
        //FIXME return this.isParticipacaoVirtual;
        return false;
    }

    get isItensObrigatoriosPreenchidos() {
        return !!(this.parteSelecionada && this.advogadoSelecionado && this.presenca && this.modoParticipacao);
    }

    get dicaBotaoGravar() {
        if (this.isItensObrigatoriosPreenchidos) {
            if (this.isDadosNovosIguaisAosAntigos) {
                return 'Dados idênticos aos anteriores!';
            } else if (this.isDadosInconsistentes) {
                return 'Dados informados apresentam não conformidades!';
            } else {
                return this.observableProps.editar ? 'Atualizar inscrição' : 'Adicionar inscrição';
            }
        }

        return this.msgDadosObrigatorios;
    }

    get msgDadosObrigatorios() {
        let msg = 'Informe: ';

        if (!this.parteSelecionada) {
            msg += 'parte representada, ';
        }

        if (!this.advogadoSelecionado) {
            msg += 'nome, informação de presença e modo de participação do advogado, ';
        } else {
            if (!this.advogadoSelecionado.nome) {
                msg += 'nome do advogado, ';
            }

            if (!this.presenca) {
                msg += 'informação de presença do advogado, ';
            }

            if (!this.modoParticipacao) {
                msg += 'modo de participação do advogado, ';
            }
        }

        const ultimaVirgula = msg.lastIndexOf(', ');
        return `${msg.slice(0, ultimaVirgula)}.`;
    }

    get titulo() {
        const numeroProcesso = NumeroProcessoUtil.formatarNumeroProcesso(
            this.registro.processo.numeroCompleto,
            false,
            true
        );
        const textoProcesso = ` (processo ${numeroProcesso})`;
        return `${this.observableProps.editar ? 'Alterar' : 'Incluir'} inscrição de advogado${textoProcesso}`;
    }

    get msgFormHelperTextPesquisaNomeAdv() {
        return `Informe a OAB ou ao menos ${IncluirSustentacaoOral.QTD_MINIMA_CARACTERES_PARA_PESQUISAR} caracteres do nome para consulta.`;
    }

    handleSelectDocumentos = (documentos) => {
        this.documentos = documentos;
    };

    render() {
        if (!this.isComponenteHabilitado('IncluirSustentacaoOral')) {
            return null;
        }

        const RECUO_ESQUERDA = '10px';
        const ESPACO_ENTRE_CAMPOS = '20px';

        return (
            <>
                <IconButton
                    onClick={this.abrir}
                    style={{ padding: '4px' }}
                    size="large"
                >
                    <Tooltip
                        placement="top"
                        title={<Typography className="tooltipBotao">{this.titulo}</Typography>}
                    >
                        {this.observableProps.editar ? (
                            <EditIcon style={{ color: 'black', fill: 'black' }} />
                        ) : (
                            <FontAwesomeIcon
                                icon={IconeParticipacaoAdvogado}
                                style={{ width: '21px', height: '21px', color: 'black', fill: 'black' }}
                            />
                        )}
                    </Tooltip>
                </IconButton>
                {this.aberto && (
                    <Dialog
                        open={this.aberto}
                        onClose={this.fechar}
                        maxWidth="xl"
                    >
                        <DialogTitle>{this.titulo}</DialogTitle>
                        <DialogContent sx={{ minWidth: 'auto', width: 750, maxWidth: '100%' }}>
                            <Stack
                                direction="column"
                                sx={{ mt: ESPACO_ENTRE_CAMPOS }}
                            >
                                <FormControl>
                                    <FormLabel
                                        required
                                        id="parte-representada-label"
                                    >
                                        Parte representada
                                    </FormLabel>
                                    <AutoComplete
                                        aria-label="parte-representada-label"
                                        value={this.parteSelecionada ? this.parteSelecionada.nome : null}
                                        options={this.opcoesPartes}
                                        onChange={this.handleChangeParte}
                                        apresentarTextoSecundario={true}
                                    />
                                </FormControl>
                            </Stack>
                            <Stack
                                direction="column"
                                sx={{ mt: ESPACO_ENTRE_CAMPOS }}
                            >
                                <FormControl>
                                    <FormLabel id="radio-buttons-group-forma-pesquisa-nome-advogado-label">
                                        Modo de pesquisa de nome
                                    </FormLabel>
                                    <RadioGroup
                                        aria-label="radio-buttons-group-forma-pesquisa-nome-advogado-label"
                                        name="opcao"
                                        value={this.formaPesquisaNomeAdv}
                                        onChange={this.handleChangeFormaPesquisaAdvogado}
                                    >
                                        <FormControlLabel
                                            style={{ marginLeft: RECUO_ESQUERDA }}
                                            label="(busca mais rápida) Nome do advogado inicia com..."
                                            value="inicia"
                                            control={<Radio onChange={this.handleChangeFormaPesquisaAdvogado} />}
                                        />
                                        <FormControlLabel
                                            style={{ marginLeft: RECUO_ESQUERDA }}
                                            label="(busca mais lenta) Nome do advogado contém..."
                                            value="contem"
                                            control={<Radio onChange={this.handleChangeFormaPesquisaAdvogado} />}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Stack>
                            <Stack
                                direction="column"
                                sx={{ mt: ESPACO_ENTRE_CAMPOS }}
                            >
                                <FormControl>
                                    <FormLabel
                                        required
                                        id="advogado-label"
                                    >
                                        Advogado(a)
                                    </FormLabel>
                                    <Stack direction="row">
                                        <AutoComplete
                                            aria-label="advogado-label"
                                            outlined
                                            open={this.abrirAdvogados}
                                            onOpen={this.abrirAutoCompleteAdvogado}
                                            onBlur={this.fecharAutoCompleteAdvogado}
                                            value={this.campoTextoAdvogado}
                                            options={this.opcoesAdvogados}
                                            isOptionEqualToValue={(option, value) => {
                                                return this.isMesmaOpcaoAdvogado(option, value);
                                            }}
                                            onInputChange={this.handleInputChangeAdvogado}
                                            onChange={this.handleChangeAdvogado}
                                            loading={this.aguardandoConsultaAdvogados}
                                        />
                                        <ModalEdicaoAdvogadoProcesso
                                            registro={this.registro}
                                            callback={this.callbackCadastrarAdvogado}
                                        />
                                    </Stack>
                                </FormControl>
                            </Stack>
                            <Box>
                                <FormHelperText>{this.msgFormHelperTextPesquisaNomeAdv}</FormHelperText>
                            </Box>
                            {!this.isDadosNovosIguaisAosAntigos && (
                                <>
                                    <Stack
                                        direction="row"
                                        sx={{ mt: ESPACO_ENTRE_CAMPOS }}
                                    >
                                        <FormControl>
                                            <FormLabel
                                                required
                                                id="radio-buttons-group-modo-participacao-label"
                                            >
                                                Modo de participação
                                            </FormLabel>
                                            <RadioGroup
                                                aria-labelledby="radio-buttons-group-modo-participacao-label"
                                                name="Participação"
                                                row
                                                value={this.modoParticipacao}
                                                onChange={this.handleChangeModoParticipacaoAdv}
                                            >
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA }}
                                                    value={MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo}
                                                    control={<Radio />}
                                                    label={MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.descricao}
                                                    labelPlacement="end"
                                                    disabled={true}
                                                />
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA }}
                                                    value={MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo}
                                                    control={<Radio />}
                                                    label={this.renderOpcaoPresencial(
                                                        MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.descricao
                                                    )}
                                                    labelPlacement="end"
                                                    disabled={
                                                        this.isDadosNovosIguaisAosAntigos ||
                                                        this.isJulgamentoExclusivamenteVirtual
                                                    }
                                                />
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA }}
                                                    value={MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo}
                                                    control={<Radio />}
                                                    label={this.renderOpcaoPresencial(
                                                        MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.descricao
                                                    )}
                                                    labelPlacement="end"
                                                    disabled={
                                                        this.isDadosNovosIguaisAosAntigos ||
                                                        this.isJulgamentoExclusivamenteVirtual
                                                    }
                                                />
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA }}
                                                    value={MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo}
                                                    control={<Radio />}
                                                    label={this.renderOpcaoVirtual()}
                                                    labelPlacement="end"
                                                    disabled={
                                                        this.isDadosNovosIguaisAosAntigos ||
                                                        this.isJulgamentoExclusivamentePresencial()
                                                    }
                                                />
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA }}
                                                    value={
                                                        MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
                                                    }
                                                    control={<Radio />}
                                                    label={this.renderOpcaoSustentacaoOralEletronica()}
                                                    labelPlacement="end"
                                                    disabled={
                                                        this.isDadosNovosIguaisAosAntigos ||
                                                        !this.registro.processo.permiteSustentacao ||
                                                        this.isJulgamentoExclusivamentePresencial()
                                                    }
                                                />
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA }}
                                                    value={MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo}
                                                    control={<Radio />}
                                                    label={this.renderOpcaoPedidoDestaque()}
                                                    labelPlacement="end"
                                                    disabled={
                                                        this.isDadosNovosIguaisAosAntigos ||
                                                        !this.registro.processo.permiteDestaque ||
                                                        !SituacaoJulgamentoProcessoBusiness.isProcessoPautadoEmJulgamentoExclusivamenteVirtual(
                                                            this.sessaoStore.sessaoSelecionada.tipoJulgamento
                                                        )
                                                    }
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Stack>
                                    {this.modoParticipacao ===
                                        MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo && (
                                        <Stack>
                                            <Box
                                                sx={{
                                                    my: 2,
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    flexDirection: 'column'
                                                }}
                                            >
                                                <SustentacaoOralEletronicaDialog
                                                    onSelect={this.handleSelectDocumentos}
                                                    documentos={this.documentos}
                                                />
                                                <Typography sx={{ mt: 1, color: grey[600], fontSize: '14px', mr: 1.5 }}>
                                                    {this.documentos.length > 0
                                                        ? `${this.documentos.length} documento(s) selecionado(s)`
                                                        : ''}
                                                </Typography>
                                            </Box>
                                        </Stack>
                                    )}
                                    <Stack
                                        direction="row"
                                        sx={{ mt: ESPACO_ENTRE_CAMPOS }}
                                    >
                                        <FormControl>
                                            <FormLabel
                                                required={this.isJulgamentoPresencial}
                                                id="radio-buttons-group-presenca-label"
                                            >
                                                Informação de presença
                                            </FormLabel>
                                            <RadioGroup
                                                aria-labelledby="radio-buttons-group-presenca-label"
                                                name="Presença"
                                                row
                                                value={this.presenca}
                                                onChange={this.handleChangePresencaAdv}
                                            >
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA, width: '180px' }}
                                                    value={SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.codigo}
                                                    control={<Radio />}
                                                    label={SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.descricaoPresencaCurta}
                                                    labelPlacement="end"
                                                    disabled={this.isControlePresencaDesabilitado}
                                                />
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA, width: '130px' }}
                                                    value={SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.codigo}
                                                    control={<Radio />}
                                                    label={SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.descricaoPresencaCurta}
                                                    labelPlacement="end"
                                                    disabled={this.isControlePresencaDesabilitado}
                                                />
                                                <FormControlLabel
                                                    style={{ marginLeft: RECUO_ESQUERDA }}
                                                    value={SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.codigo}
                                                    control={<Radio />}
                                                    label={SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.descricaoPresencaCurta}
                                                    labelPlacement="end"
                                                    disabled={this.isControlePresencaDesabilitado}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Stack>
                                </>
                            )}

                            {this.observableProps.editar && (
                                <Stack
                                    direction="row"
                                    sx={{ mt: ESPACO_ENTRE_CAMPOS }}
                                >
                                    <FormControl>
                                        <FormLabel id="radio-buttons-group-estado-sustentacao-label">Estado</FormLabel>
                                        <RadioGroup
                                            aria-labelledby="radio-buttons-group-estado-sustentacao-label"
                                            name="estadoSustentacaoOral"
                                            row
                                            value={this.estadoSustentacaoOral?.toString() || ''}
                                            onChange={this.handleChangeEstadoSustentacaoOral}
                                        >
                                            <FormControlLabel
                                                style={{ marginLeft: RECUO_ESQUERDA }}
                                                value={ESTADO_SUSTENTACAO_ORAL.SUSTENTOU.codigo.toString()}
                                                control={<Radio />}
                                                label={ESTADO_SUSTENTACAO_ORAL.SUSTENTOU.descricao}
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                style={{ marginLeft: RECUO_ESQUERDA }}
                                                value={ESTADO_SUSTENTACAO_ORAL.NAO_SUSTENTOU.codigo.toString()}
                                                control={<Radio />}
                                                label={ESTADO_SUSTENTACAO_ORAL.NAO_SUSTENTOU.descricao}
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                style={{ marginLeft: RECUO_ESQUERDA }}
                                                value={ESTADO_SUSTENTACAO_ORAL.TEVE_ASSEGURADA.codigo.toString()}
                                                control={<Radio />}
                                                label={ESTADO_SUSTENTACAO_ORAL.TEVE_ASSEGURADA.descricao}
                                                labelPlacement="end"
                                            />
                                            <FormControlLabel
                                                style={{ marginLeft: RECUO_ESQUERDA }}
                                                value={ESTADO_SUSTENTACAO_ORAL.NAO_TEVE_ASSEGURADA.codigo.toString()}
                                                control={<Radio />}
                                                label={ESTADO_SUSTENTACAO_ORAL.NAO_TEVE_ASSEGURADA.descricao}
                                                labelPlacement="end"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Stack>
                            )}

                            {this.observableProps.editar &&
                                this.modoParticipacao ===
                                    MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo && (
                                    <Stack>
                                        <GerenciarSustentacaoOralDialog
                                            sessaoId={this.registro?.sessaoId}
                                            numeroProcesso={this.registro?.processo?.numeroCompleto}
                                            representanteId={this.inscricao?.advogado?.regOAB?.id?.replace('/', '-')}
                                            codigoParte={this.inscricao?.codigoDaParte}
                                            inscricaoId={this.inscricao?.id}
                                        />
                                    </Stack>
                                )}

                            <Stack
                                direction="column"
                                sx={{ mt: ESPACO_ENTRE_CAMPOS }}
                            >
                                <FormControl>
                                    <FormLabel
                                        required
                                        id="data-inscricao"
                                    >
                                        Data de solicitação da inscrição
                                    </FormLabel>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            ampm={false}
                                            format="DD/MM/YYYY HH:mm:ss"
                                            views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
                                            value={this.dataSolicitacaoInscricaoObj}
                                            onChange={this.handleChangeDataInscricao}
                                            disabled={
                                                !this.advogadoSelecionado ||
                                                this.registro.processo.origem !== Configuracao.ORIGEM_PJE
                                            }
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Stack>
                        </DialogContent>
                        <DialogActions sx={{ mr: 2, mb: 1 }}>
                            <Button
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                                onClick={this.fechar}
                            >
                                Cancelar
                            </Button>
                            <Tooltip title={<Typography className="tooltipBotao">{this.dicaBotaoGravar}</Typography>}>
                                <span>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        disabled={
                                            this.isDadosNovosIguaisAosAntigos ||
                                            !this.isItensObrigatoriosPreenchidos ||
                                            this.isDadosInconsistentes ||
                                            this.executandoAcao
                                        }
                                        endIcon={this.observableProps.editar ? <SaveIcon /> : <AddCircleIcon />}
                                        onClick={this.handleClickGravarInscricaoAdvogado}
                                        sx={{ ml: 2 }}
                                        loading={this.executandoAcao}
                                    >
                                        {this.observableProps.editar ? 'Salvar' : 'Incluir'}
                                    </Button>
                                </span>
                            </Tooltip>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(IncluirSustentacaoOral));
